import React from 'react';

export const BOPIS = 'BOPIS';
export const BOSS = 'BOSS';
export const ShipToStore = 'ShipToStore';
export const DeliverFromStore = 'DeliverFromStore';
export const ShipToHome = 'ShipToHome';

export const NotAvailable = 'NA';
export const LimitedStock = 'Limited Stock';
export const InStock = 'In Stock';
export const OutofStock = 'Out of Stock';

export const FullFillmentsMapper = {
  [ShipToStore]: 'boss',
  [BOPIS]: 'bopis',
  [DeliverFromStore]: 'bodfs',
  [ShipToHome]: 'sth',
};

export const totalSquareFeet = 'countertops-total-square-feet';
export const totalFinishedLengthFeet = 'countertops-total-finished-length-feet';
export const ctPartialArea = 'countertops-ct-partial-area';
export const bsPartialArea = 'countertops-bs-partial-area';
export const oversizedOptionTag = 'countertops-oversized-slab';
export const overSizedSeamChoiceTag = 'countertops-oversized-no';
export const overSizedSeamlessChoiceTag = 'countertops-oversized-yes';
export const LAMINATE_PRODUCT_ID = 539854; // Need to swap for attribute on product
export const customSplashesTag = 'countertops-custom-splashes';
export const postformEndSplashesTag = 'countertops-postform-endsplashes';

export const partialPayStateCodes = ['ME', 'MD', 'MA', 'NJ', 'WI'];

export const noImgGuid = '0a7aed12-0b00-ea11-9476-0a986990730e';

export const SortOrder = {
  Asc: 'asc',
  Desc: 'desc',
};

export const SortColorsBy = {
  Featured: 'Featured',
  PriceAsc: 'PriceAsc',
  PriceDesc: 'PriceDesc',
  NameAsc: 'NameAsc',
  NameDesc: 'NameDesc',
};

export const SwatchObjPropertyPaths = {
  imageUrl: 'imageUrl',
  mediaUrl: 'mediaUrl',
  name: 'name',
  price: 'price',
  shortLabel: 'shortLabel',
};

export const SINK_SOURCE_PATTERN = /itemize-label:\s*Sink\s+(\d+)\s+Source/i;
export const SINK_SOURCE_PATTERN_NO_CAPTURE = /itemize-label:\s*Sink\s+\d+\s+Source/i;

export const BUY_NOW_CHOICE = 'Buy_Now';

export const SINK_QUANTITY_TAG = 'itemize-label:Sink Quantity';

export const SINK_STEPPER_MAX = 5;

export const HOME_DEPOT_ORANGE = '#f96832';

export const OversizedWarningText = (overSizedShapes, handleOverSizedInfoModal) => {
  const multipleShapes = overSizedShapes?.length > 1;
  const formattedShapeString = overSizedShapes
    ?.map((shape) => shape?.label.replace('Shape', ''))
    .join(',');

  return (
    <span style={{ fontSize: '1.6rem', textWrap: 'balance' }}>
      This design contains an oversized piece. An oversized piece charge has been added to the total
      price. For more information, including details on how to avoid this charge by using seams{' '}
      <span
        role="button"
        tabIndex="0"
        style={{ cursor: 'pointer', textDecoration: 'underline' }}
        onClick={() => handleOverSizedInfoModal()}
      >
        Click Here.
      </span>
    </span>
  );
};
